import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select, Pagination } from 'components';
import { OrderService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { ArrowLeftWhite, CleanIcon, CloseIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
	onClose?: any;
	onConfirm?: any;
}

class ModalConfirmPayment extends React.Component<Props> {

	render() {
		return (
			<div id="modal-confirm-order">
				<div className="text-right">
					<button className="btn-close" onClick={ () => this.props.onClose() }>
						<img src={ CloseIcon } />
					</button>
				</div>
				<p style={{ paddingTop: '10px' }}>¿Desea aceptar o rechazar el pago?</p>
				<div className="container-buttons">
					<button className="btn-cancel" onClick={ () => this.props.onConfirm(Constants.ORDERS_PAYMENT_STATUS.REJECTED) }>
						Rechazar
					</button>
					<button className="btn-submit" onClick={ () => this.props.onConfirm(Constants.ORDERS_PAYMENT_STATUS.ACCEPTED) }>
						Aceptar
					</button>
				</div>
			</div>
		)
	}
}

export default ModalConfirmPayment;